import * as React from "react";

function NoteIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="none" height="1em" width="1em" {...props}>
			<path
				d="M6.75 3.75h10.5A2.25 2.25 0 0 1 19.5 6v8.04a2.25 2.25 0 0 1-.659 1.591l-2.55 2.55a2.25 2.25 0 0 1-1.591.659h-7.95A2.25 2.25 0 0 1 4.5 16.5V6a2.25 2.25 0 0 1 2.25-2.25Z"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M9 8.25h6M9 11.75h6M9 15.25h3.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M15.75 18.75v-2.7a1.35 1.35 0 0 1 1.35-1.35h2.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
		</svg>
	);
}

export default NoteIcon;
